var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pl-9 pr-8 pt-8",attrs:{"no-gutters":""}},[_c('EmailingConnectionsOverview',{attrs:{"title":_vm.$t('Send emails')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }